<template>
  <!-- NOTE (TEMPLATE) to build a general review and use it in the project as a component -->

  <div class="animated fadeIn">
    <table class="table table-striped">
      <tbody>
        <tr>
          <td>نقاط قوت و ضعف متقاضی از دید داور</td>
          <td>
            <b-form-textarea
              trim
              :disabled="disabled"
              v-model="refereeIdea2"
            ></b-form-textarea>
          </td>
        </tr>
        <tr>
          <td>نظر نهایی داور</td>
          <td>
            <b-form-select
              :disabled="disabled"
              :options="refereeDecisions"
              v-model="refereeDecision2"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="!disabled">
      <p variant="danger" v-if="!(refereeDecision2 && refereeIdea2)">
        لطفا به منظور ثبت داوری نقاط قوت و ضعف را مشخص کنید و نظر نهایی خود را
        نیز انتخاب کنید.
      </p>
      <p></p>
      <div class="d-flex justify-content-center">
        <!-- NOTE (b-sendReview) to send review -->
        <b-button
          variant="success"
          class="mx-2"
          :disabled="!(refereeDecision2 && refereeIdea2) || isBusy"
          @click="
            sendReview();
            isBusy = true;
          "
          >ارسال داوری</b-button
        >
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../main"; // REVIEW

export default {
  name: "Reviewing",
  props: ["disabled", "scoresData", "refereeIdea", "refereeDecision"],
  components: {},

  data() {
    return {
      isBusy: false,

      score: [0],
      weight: [0],
      refereeDecision2: this.refereeDecision,
      refereeIdea2: this.refereeIdea,
      refereeDecisions: [
        { value: null, text: "لطفا نظر خود را انتخاب کنید", disabled: true },
        { value: "accept", text: "مورد تایید است" },
        {
          value: "minorRevision",
          text: "با اصلاحات بدون نیاز به داوری مجدد مورد تایید است",
        },
        {
          value: "majorRevision",
          text: "نیازمند اصلاحات و داوری مجدد",
        },
        { value: "reject", text: "مورد تایید نیست" },
      ],
    };
  },

  computed: {},
  methods: {
    sendReview() {
      // NOTE (m-sendReview) to send review
      this.$http
        .post(
          this.baseUrl + "/setad/reviewer/review/elite/done",
          {
            reviewId: this.$route.params.judgeId,
            description: this.refereeIdea2,
            decision: this.refereeDecision2,
            scores: [],
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            EventBus.$emit("refereeAdded", {});
            this.$router.replace("/referee/archive");
          } else if (res.status == 202) {
            this.toast(res.data.text, "success");
            this.toast(res.data.error, "error");
            this.$router.replace("/referee/archive");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            this.$router.push({
              path: "/unauthorize",
              query: { return: window.location.pathname },
            });
          }
        });

      this.fileBusy = false;
    },
  },
  mounted() {
    // NOTE (MOUNTED) to show data of proposal score
    // this.refereeDecision2 = null;
    if (this.scoresData) this.score = this.scoresData;
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
</style>
